import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../css/OnRent.css";
import {
  onRentInfo,
  onRentError,
  onRentUpdatedTime,
  onRentLoading,
  onRentHandleMsg,
  fetchAsyncOnRent,
  fetchAsyncLock,
  fetchAsyncUnlock,
  fetchAsyncEndRent,
} from "./OnRentSlice";
import { PortInfoStatus, fetchAsyncPortInfo } from "../portInfo/PortInfoSlice";
import { useHistory } from "react-router-dom";
import { format } from "date-fns-tz";
import { DateConverter } from "../../utils/DateConverter";

const OnRent: React.FC = () => {
  //レンタル中情報
  const onRentData = useSelector(onRentInfo);
  //エラー時メッセージ
  const onRentErrorMsg = useSelector(onRentError);
  //ロード中判定
  const onRentLoadingJudge = useSelector(onRentLoading);
  //データ取得時間
  const onRentGetTime = useSelector(onRentUpdatedTime);
  //機体処理後のレスポンス表示
  const onRentHandleAlert = useSelector(onRentHandleMsg);
  const dispatch = useDispatch();

  //機体処理のbodyに入る
  const [selectedId, setSelectedId] = useState<number>(0);
  const [selectedPortId, setSelectedPortId] = useState<number>(0);
  const [selectedEndDate, setSelectedEndDate] = useState<string>("");

  //一意のレンタルIDを選択
  const handleRentId = (id: number) => {
    setSelectedId((prevId) => (prevId === id ? 0 : id));
  };

  //レンタル終了のモーダルフラグの判定
  const [endRentFlug, setEndRentFlug] = useState(false);
  const handleRentFlug = () => {
    setEndRentFlug(!endRentFlug);
  };

  //ロック関数
  const handleLock = (
    e: React.MouseEvent<HTMLButtonElement>,
    id: number | string
  ) => {
    e.preventDefault();
    dispatch(fetchAsyncLock({ rent_id: id }));
  };

  //アンロック関数
  const handleUnlock = (
    e: React.MouseEvent<HTMLButtonElement>,
    id: number | string
  ) => {
    e.preventDefault();
    dispatch(fetchAsyncUnlock({ rent_id: id }));
  };

  //レンタル処理関数
  const handleEndRent = (
    e: React.MouseEvent<HTMLButtonElement>,
    id: number,
    end_port_id: number,
    end_date: string
  ) => {
    e.preventDefault();
    if (id && end_port_id && end_date) {
      dispatch(
        fetchAsyncEndRent({
          rent_id: id,
          end_port_id: Number(end_port_id),
          end_date: end_date,
        })
      );
    }
  };

  //レンタル中データ取得
  useEffect(() => {
    //状態が初期値だったらAPIリクエスト
    if (onRentData === null) {
      dispatch(fetchAsyncOnRent());
    }
  }, [dispatch]);

  //optionのプルダウン
  //ポート情報がstoreにすでに入っていたらそれを使う
  const portInfoData = useSelector(PortInfoStatus);
  useEffect(() => {
    if (portInfoData === null) {
      dispatch(fetchAsyncPortInfo());
    }
  }, [endRentFlug]);

  //レンタル終了時のモーダル
  const Detail = () => {
    if (endRentFlug) {
      return (
        <div className="end_rent_detail_container">
          <div className="end_rent_detail_date">
            <span>レンタル終了日時: </span>
            <input
              type="datetime-local"
              onChange={(e) => setSelectedEndDate(String(e.target.value))}
              value={selectedEndDate ?? ""}></input>
          </div>
          <div className="end_rent_detail_port">
            <span>返却ポート: </span>
            <select
              name="change_port"
              className="change_input"
              onChange={(e) => setSelectedPortId(Number(e.target.value))}
              value={selectedPortId}
              required>
              <option
                value=""
                selected={
                  selectedPortId === undefined || selectedPortId === null
                }>
                返却ポートを選択してください
              </option>
              {portInfoData!.map((item: any, index: number) => (
                <option key={index} value={item.port_id}>
                  {item.port_id} {item.port_name}
                </option>
              ))}
            </select>
          </div>
          <button
            className="end_rent_detail_button"
            onClick={(e) =>
              handleEndRent(e, selectedId, selectedPortId, selectedEndDate)
            }>
            レンタルを終了
          </button>
        </div>
      );
    }
    return null;
  };

  //リダイレクト用
  const history = useHistory();
  //詳細ページに飛ぶ
  const jumpToDetail = (item: any) => {
    history.push("/User_detail", { user_id: item });
  };

  return (
    <div className="position_row">
      <div className="on_rent_container">
        {endRentFlug && selectedId !== 0 && <Detail />}
        <h1 className="on_rent_title">レンタル中情報</h1>

        <div className="on_active_container">
          <button onClick={handleRentFlug}>レンタル終了</button>
          {/* <button onClick={(e) => handleLock(e, selectedId)}>ロック</button>
          <button onClick={(e) => handleUnlock(e, selectedId)}>
            アンロック
          </button> */}
        </div>

        <div className="time">最終更新時間 : {onRentGetTime}</div>
        <table className="item_container">
          <thead>
            <tr className="on_rent_item_container">
              <td className="box">　</td>
              <td className="box">レンタルID</td>
              <td className="box">ユーザ名</td>
              <td className="item">開始ポート</td>
              <td className="item">開始日時</td>
              <td className="item">車体ナンバー</td>
            </tr>
          </thead>
          <tbody>
            {onRentData !== null &&
              onRentData.map((item) => (
                <tr key={item.rent_id} className="on_rent_item_container">
                  <td className="box">
                    <input
                      type="checkbox"
                      checked={selectedId === item.rent_id}
                      onChange={() => handleRentId(item.rent_id)}
                    />
                  </td>
                  <td className="box">{item.rent_id}</td>
                  <td
                    className="item"
                    onDoubleClick={() => {
                      // jumpToDetail(item.user_id);
                    }}>
                    {item.family_name} {item.first_name}
                  </td>
                  <td className="item">{item.start_port_name}</td>
                  <td className="item">{DateConverter(item.start_date)}</td>
                  <td className="item">{item.body_number}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default OnRent;
